import EmployeesInner from './EmployeesInner';

export default EmployeesInner;
